import { render, staticRenderFns } from "./SpeakingAssessment.vue?vue&type=template&id=3a29a011&scoped=true"
import script from "./SpeakingAssessment.vue?vue&type=script&lang=js"
export * from "./SpeakingAssessment.vue?vue&type=script&lang=js"
import style0 from "./SpeakingAssessment.vue?vue&type=style&index=0&id=3a29a011&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a29a011",
  null
  
)

export default component.exports